import { EnvironmentService } from 'shared/services';

export const getPlatformClient = () => {
  const platformClient = EnvironmentService.getVariable('PLATFORM_CLIENT');

  return platformClient;
};
